"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var VipModule = /** @class */ (function (_super) {
    __extends(VipModule, _super);
    function VipModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 根据userid查询用户验证信息
     * @param userId
     */
    VipModule.prototype.queryUserById = function (userId, token) {
        return this.gatewayClient.queryUserById(userId, token);
    };
    /**
     * oms人脸照片验证
     * @param userId
     * @param imageFace
     * @param imgType
     * @param phone
     * @param auditStatus
     */
    VipModule.prototype.omsFaceAudit = function (params, token) {
        return this.gatewayClient.omsFaceAudit(params, token);
    };
    /**
     * oms人工审核人脸
     * @param userId
     * @param imageFace
     * @param auditStatus
     */
    VipModule.prototype.omsFaceAuditHandle = function (params, token) {
        return this.gatewayClient.omsFaceAuditHandle(params, token);
    };
    /**
     * oms身份证照片验证
     * @param backImg
     * @param frontImg
     * @param imgType
     * @param phone
     * @param userId
     */
    VipModule.prototype.omsCardAudit = function (params, token) {
        return this.gatewayClient.omsCardAudit(params, token);
    };
    /**
     * oms身份证验证
     * @param userId
     * @param backImg
     * @param frontImg
     * @param idValidDate
     * @param idNo
     * @param name
     * @param phone
     * @param state
     */
    VipModule.prototype.omsIdAudit = function (params, token) {
        return this.gatewayClient.omsIdAudit(params, token);
    };
    /**
     * oms港澳台身份验证 3.6.2
     * @param certificateAuditStatus	港澳台/外籍人士证件审核状态，1待审核 2 已验证 3审核不通过
     * @param certificateIdNo	证件号
     * @param certificateRejectReason	外籍人士证件审核不通过原因
     * @param certificateValid	证有效日期
     * @param image1	证正面
     * @param image2	人脸正面
     * @param imageType	决定图片获取方式1从微信的素材ID,2七牛url
     * @param name
     * @param userId
     */
    VipModule.prototype.certificateAudit = function (params, token) {
        return this.gatewayClient.certificateAudit(params, token);
    };
    /**
     * 获取七牛私有token
     * @param imgUrl
     */
    VipModule.prototype.getPrivateToken = function (imgUrl, token) {
        return this.gatewayClient.getPrivateToken(imgUrl, token);
    };
    return VipModule;
}(gateway_module_1.GatewayModule));
exports.VipModule = VipModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy92aXAvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBRUEsb0RBQWtEO0FBRWxEO0lBQStCLDZCQUFhO0lBQTVDOztJQWtJQSxDQUFDO0lBaklDOzs7T0FHRztJQUNJLGlDQUFhLEdBQXBCLFVBQXFCLE1BQWMsRUFBRSxLQUFhO1FBQ2hELE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGFBQWEsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDekQsQ0FBQztJQUVEOzs7Ozs7O09BT0c7SUFDSSxnQ0FBWSxHQUFuQixVQUNFLE1BS0MsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsWUFBWSxDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUN4RCxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxzQ0FBa0IsR0FBekIsVUFDRSxNQUlDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGtCQUFrQixDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM5RCxDQUFDO0lBRUQ7Ozs7Ozs7T0FPRztJQUNJLGdDQUFZLEdBQW5CLFVBQ0UsTUFNQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3hELENBQUM7SUFFRDs7Ozs7Ozs7OztPQVVHO0lBQ0ksOEJBQVUsR0FBakIsVUFDRSxNQVNDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLFVBQVUsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDdEQsQ0FBQztJQUVEOzs7Ozs7Ozs7OztPQVdHO0lBQ0ksb0NBQWdCLEdBQXZCLFVBQ0UsTUFVQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxnQkFBZ0IsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDNUQsQ0FBQztJQUVEOzs7T0FHRztJQUNJLG1DQUFlLEdBQXRCLFVBQXVCLE1BQWMsRUFBRSxLQUFhO1FBQ2xELE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGVBQWUsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDM0QsQ0FBQztJQUNILGdCQUFDO0FBQUQsQ0FBQyxBQWxJRCxDQUErQiw4QkFBYSxHQWtJM0M7QUFsSVksOEJBQVMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/vip/index.js
// module id = 218
// module chunks = 44